import React from "react";

/**
 * Catches ChunkLoadError (lazy-loaded chunk fails) and auto-reloads once.
 * Prevents the app from showing a blank screen after a new deployment
 * or when a stale chunk is requested.
 */
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError =
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("Failed to fetch dynamically imported module") ||
      error?.message?.includes("Importing a module script failed");

    return { hasError: isChunkError };
  }

  componentDidCatch(error) {
    const isChunkError =
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("Failed to fetch dynamically imported module") ||
      error?.message?.includes("Importing a module script failed");

    if (isChunkError) {
      // Reload once to pick up the new chunks.
      // Use sessionStorage to avoid infinite reload loops.
      const reloadKey = "chunkErrorReloaded";
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, "1");
        window.location.reload();
      } else {
        // Already tried reloading — clear flag so next session can retry
        sessionStorage.removeItem(reloadKey);
      }
    }
  }

  render() {
    // While reloading, render nothing (or a spinner if preferred)
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
